module.exports = __webpack_public_path__ + "static/Henry-0324873a945c00bb58d1ca00bcf66dd0.png";